document.addEventListener('DOMContentLoaded', function() {
    const filterBtns = document.querySelectorAll('.blog-filter-btn');
    const blogGrid = document.getElementById('blog-grid');
    const paginationContainer = document.getElementById('blog-pagination');
    let currentCategory = 'all';
    
    // Fallback to globally localized variable or define locally
    const ajaxurl = typeof ajax_auth_object !== 'undefined' ? ajax_auth_object.ajaxurl : (typeof lykwow_ajax_object !== 'undefined' ? lykwow_ajax_object.ajaxurl : '/wp-admin/admin-ajax.php');

    function loadBlogs(paged = 1) {
        if (!blogGrid) return;

        // Visual loading state
        blogGrid.style.opacity = '0.5';
        if (paginationContainer) paginationContainer.innerHTML = '';
        
        const formData = new URLSearchParams();
        formData.append('action', 'get_blogs_ajax');
        formData.append('category', currentCategory);
        formData.append('paged', paged);

        fetch(ajaxurl, {
            method: 'POST',
            body: formData,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        })
        .then(response => response.json())
        .then(data => {
            blogGrid.style.opacity = '1';
            
            if (data.success) {
                blogGrid.innerHTML = data.data.posts;
                if (paginationContainer) {
                    paginationContainer.innerHTML = data.data.pagination;
                    
                    // Attach event listeners to new pagination links
                    attachPaginationEvents();
                }
            } else {
                blogGrid.innerHTML = '<div class="col-12 text-center py-5"><p>No posts found in this category.</p></div>';
            }
        })
        .catch(error => {
            blogGrid.style.opacity = '1';
            console.error('Error fetching blogs:', error);
            blogGrid.innerHTML = '<div class="col-12 text-center py-5"><p>Error loading posts. Please try again.</p></div>';
        });
    }

    function attachPaginationEvents() {
        if (!paginationContainer) return;

        const pageLinks = paginationContainer.querySelectorAll('.page-numbers');
        pageLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                if (this.classList.contains('current')) return;
                
                let pageNum = 1;
                
                if (this.classList.contains('next')) {
                    const current = paginationContainer.querySelector('.current');
                    pageNum = current ? parseInt(current.innerText) + 1 : 1;
                } else if (this.classList.contains('prev')) {
                    const current = paginationContainer.querySelector('.current');
                    pageNum = current ? parseInt(current.innerText) - 1 : 1;
                } else {
                    pageNum = parseInt(this.innerText);
                }

                if (!isNaN(pageNum)) {
                    loadBlogs(pageNum);
                    window.scrollTo({ 
                        top: blogGrid.getBoundingClientRect().top + window.pageYOffset - 150, 
                        behavior: 'smooth' 
                    });
                }
            });
        });
    }

    // Filter Buttons Click
    if (filterBtns.length > 0) {
        filterBtns.forEach(btn => {
            btn.addEventListener('click', function() {
                filterBtns.forEach(b => b.classList.remove('active'));
                this.classList.add('active');
                currentCategory = this.getAttribute('data-category');
                loadBlogs(1);
            });
        });

        // If grid exists, it's already rendered via PHP (SSR), just attach events
        if (blogGrid) {
            attachPaginationEvents();
        }
    }
});
